type AuthStatus = { status: string };
type UserStatus = { status: string };

export type RootScreenName =
  | "login"
  | "loading"
  | "onboarding"
  | "error"
  | "home";

/**
 * Mirrors RootRouter's branching logic as a pure function, so the screen
 * name can be used both for rendering and for driving the splash's
 * minimum-hold timer without duplicating the conditions.
 */
export const getRootScreenName = (
  authState: AuthStatus,
  userState: UserStatus,
): RootScreenName => {
  if (authState.status === "needs_login") return "login";

  if (userState.status === "idle" || userState.status === "loading") {
    return "loading";
  }

  if (
    userState.status === "not_registered" ||
    userState.status === "onboarding_in_progress"
  ) {
    return "onboarding";
  }

  if (userState.status === "error") return "error";

  return "home";
};
